import Markers from '@routes/Workflow/Markers'
import WorkflowOrJobBars from '@routes/Workflow/Workflow'
import { assignWorkflowRows } from '@routes/Workflow/util'

import type { WorkflowResponse } from '@state/workflow.ts'

interface WorkflowTimelineProps {
  workflows: WorkflowResponse[]
  selectWorkflow: (workflowId: string) => void
}

function WorkflowTimeline({ workflows, selectWorkflow }: WorkflowTimelineProps) {
  if (workflows.length === 0) return null

  // eslint-disable-next-line react-hooks/purity -- Date.now() is used for timeline calculations
  const now = Date.now()

  // Calculate from workflow times
  const times = workflows.flatMap(w => [
    new Date(w.createdAt).getTime(),
    // Use current time for running workflows, otherwise use updatedAt
    w.status === 'RUNNING' ? now : new Date(w.updatedAt).getTime(),
  ])

  const startTime = Math.min(...times)
  const endTime = Math.max(...times)

  const workflowsWithRows = assignWorkflowRows(workflows)
  const duration = endTime - startTime

  return (
    <div className="mt-8 space-y-6">
      <h3 className="text-lg font-semibold">Timeline</h3>

      <div className="relative">
        <Markers startTime={startTime} endTime={endTime} duration={duration} />

        <div className="relative">
          {workflowsWithRows.map((row, i) => {
            return (
              <div key={`track-${i}`} className="relative mb-1 h-6 w-full rounded-sm bg-gray-200">
                {row.map((workflow) => (
                  <WorkflowOrJobBars
                    key={workflow.id}
                    workflow={workflow}
                    startTime={startTime}
                    duration={duration}
                    selectWorkflow={selectWorkflow}
                  />
                ))}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default WorkflowTimeline